const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Library extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Library.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.cultureProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount() * multiplier,
                        });
                        playerState.scienceProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount()* multiplier,
                        });
                    }
            }
        )
    }
    static GetType = () => TechnologyTypes.Urban.Library;
}

class PrintingPress extends Library {
    constructor(){
        super(PrintingPress.GetAge(), PrintingPress.GetName(), 3, 3, 1)
    }

    static GetInstance = () => new PrintingPress();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Urban.PrintingPress;
}

class Journalism extends Library {
    constructor(){
        super(Journalism.GetAge(), Journalism.GetName(), 6, 8, 2)
    }

    static GetInstance = () => new Journalism();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Urban.Journalism;
}

class Multimedia extends Library {
    constructor(){
        super(Multimedia.GetAge(),Multimedia.GetName(), 9, 11, 3)
    }

    static GetInstance = () => new Multimedia();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Urban.Multimedia;
}

module.exports = {
    PrintingPress,
    Journalism,
    Multimedia
}